import { useEffect, useRef, useCallback } from 'react';

const INACTIVITY_TIMEOUT_MS = 24 * 60 * 60 * 1000; // 24 jam

/**
 * Session timeout saat tidak ada aktivitas (mouse, keyboard, scroll, touch).
 * Setelah timeout, clear session dan redirect ke beranda.
 * @param {Object} options
 * @param {number} options.timeoutMs - durasi inaktivitas (default 24 jam)
 */
export function useSessionTimeout(options = {}) {
  const timeoutMs = options.timeoutMs || INACTIVITY_TIMEOUT_MS;
  const timerRef = useRef(null);

  const clearSession = useCallback(() => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    const base = (window.location.pathname || '/').replace(/\/?$/, '');
    window.location.href = window.location.origin + base + '/#/beranda';
  }, []);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(clearSession, timeoutMs);
  }, [timeoutMs, clearSession]);

  useEffect(() => {
    if (!localStorage.getItem('user')) return;

    resetTimer();
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach((ev) => window.addEventListener(ev, resetTimer));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((ev) => window.removeEventListener(ev, resetTimer));
    };
  }, [resetTimer]);
}
